<template>
  <div id="app">
    <!-- <Home msg="Welcome to Your Vue.js App" /> -->
    <router-view></router-view>
  </div>
</template>

<script>
// import Home from "./page/Home.vue";

export default {
  name: "App",
  components: {
    // Home,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  color: #000;
  margin: 0;
  padding: 0;
}
</style>
